import { render, staticRenderFns } from "./CallLeftSidebar.vue?vue&type=template&id=4c51cbe9&scoped=true&"
import script from "./CallLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./CallLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CallLeftSidebar.vue?vue&type=style&index=0&id=4c51cbe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51cbe9",
  null
  
)

export default component.exports